import React, { KeyboardEventHandler, ReactElement, useState } from 'react'
import { QuantifiedIngredient } from '@mindfulchefuk/features/Recipes/interfaces'
import { Link, Text } from '@mindfulchefuk/design-system'
import { getIngredientAllergenString } from '@mindfulchefuk/features/Recipes/components/RecipeIngredients/utils/getIngredientAllergenString'

export const RecipeIngredient = ({
  displayTitle,
  description,
  allergens,
  possibleAllergens,
}: Pick<
  QuantifiedIngredient,
  'displayTitle' | 'description' | 'allergens' | 'possibleAllergens'
>): ReactElement => {
  const [showDescription, setShowDescription] = useState<boolean>(false)

  const allergensString = getIngredientAllergenString(
    allergens,
    possibleAllergens
  )

  const handleClick = () => setShowDescription((show) => !show)

  const handleKeyDown: KeyboardEventHandler<HTMLSpanElement> = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      setShowDescription((show) => !show)
    }
  }

  if (!description) {
    return (
      <Text as="span">
        {displayTitle}
        <Text as="span" variant="body-lg-500">
          {allergensString}
        </Text>
      </Text>
    )
  }

  return (
    <Text
      as="span"
      onClick={handleClick}
      onKeyDown={(event) => handleKeyDown(event)}
      role="button"
      tabIndex={0}
    >
      <Link as="span">{displayTitle}</Link>
      <Text as="span" variant="body-lg-500">
        {allergensString}
      </Text>
      {showDescription && (
        <Text variant="body-sm" as="span">
          {' '}
          ({description})
        </Text>
      )}
    </Text>
  )
}
